import React, { useContext } from 'react'
import { IntegrationsCol } from './integrations-col'
import { DomainIntegrationsManagerContext } from '../context'
import { BlueConicIntegrationsManager } from '../providers/blueconic/blueconic-integrations-manager'
import { FEAT_INTEGRATIONS_BLUECONIC_REC } from '../../../constants'

export const DataPlatformIntegrations: React.FC = () => {
    const { loading, domain } = useContext(DomainIntegrationsManagerContext)

    const isBlueConicFeatEnabled = domain?.flags?.includes(FEAT_INTEGRATIONS_BLUECONIC_REC) ?? false

    return !isBlueConicFeatEnabled ? null : (
        <IntegrationsCol className="data-platform-integrations" label="Data Platforms" loading={loading}>
            <BlueConicIntegrationsManager />
        </IntegrationsCol>
    )
}
